import { getSlider } from "./slider/methods/get-slider";
import { getAllNews } from "./new/methods/get-new";
import { getPromotion } from "./promotion/methods/get-promotion";
import { getPromotionList } from "./promotion/methods/get-promotion-list";
import { getPromotionDetails } from "./promotion/methods/get-promotion-details";
import { getMenu } from "./menu/methods/get-menu";
import { getContact } from "./contact/methods/get-contact";
import { getUsedProductsList } from "./usedProduct/methods/get-used-products-list";
import { getProductsList } from "./products/methods/get-products-list";
import { getFilters } from "./filters/methods/get-filters";
import { getIndustry, getIndustryBySlugAndFamilies } from "./industries/methods/get-industry";
import { getFeatureds } from "./usedProduct/methods/get-used-products-featured";
import { getUsedProductsFamilies } from "./usedProduct/methods/get-used-products-families";
import { getUsedProductsIndustries } from "./usedProduct/methods/get-used-products-industries";
import { getProductDetails } from "./products/methods/get-product-details";
import { getUsedProductsListByIndustry } from "./usedProduct/methods/get-used-products-list-by-industry";
import { getUsedProductsListByFamily } from "./usedProduct/methods/get-used-products-list-by-family";
import { getUsedProductDetails } from "./usedProduct/methods/get-used-product-details";
import { getTireList } from "./tires/methods/get-tire-list";
import { getTireIndustry } from "./tires/methods/get-tire-industry";
import { getTireDetails } from "./tires/methods/get-tire-details";
import { getOverview } from "./partsServices/methods/get-overview";
import { getCategories } from "./partsServices/methods/get-categories";
import { getCategoryDetails } from "./partsServices/methods/get-category-details";
import { getSubCategoryDetails } from "./partsServices/methods/get-subcategory-details";
import { getTireListFiltered } from "./tires/methods/get-tire-list-filtered";
import { getTechnologicalSolutions } from "./technologicalSolutions/methods/get-technological-solutions";
import { getTechnologicalSolution } from "./technologicalSolutions/methods/get-technological-solution";
import { getBranches } from "./branches/methods/get-branches";
import { getNewsCategory } from "./news/methods/get-news-category";
import { getNewsYearMonth } from "./news/methods/get-news-year-month";
import { getNewsList } from "./news/methods/get-news-list";
import { getNewsDetails } from "./news/methods/get-news-details";
import { getNewsCategoryList } from "./news/methods/get-news-category-list";
import { getContentUsedProductCertificateDetails } from "./usedProductCertificate/methods/get-content-used-product-certificate";
import { getFeaturedList } from "./promotion/methods/get-featured-list";
import { getPromotionLatestList } from "./promotion/methods/get-promotion-latest-list";
import { getBookletList } from "./booklets/methods/get-booklet-list";
import { getBookletCategory } from "./booklets/methods/get-booklet-category";
import { getBookletDate } from "./booklets/methods/get-booklet-date";
import { getBrandList } from "./brands/methods/get-brand-list";
import { getBookletListByCategory } from "./booklets/methods/get-booklet-list-by-category";
import { getBookletListBySearch } from "./booklets/methods/get-booklet-list-by-search";
import { GetBookletDetails } from "./booklets/methods/get-booklet-details";
import { getUsedProductsListBySearch } from "./usedProduct/methods/get-used-products-list-by-search";
import { getTireListBySearch } from "./tires/methods/get-tire-list-by-search";
import { getNewsListBySearch } from "./news/methods/get-news-list-by-search";
import { getNewsNewestDetails } from "./news/methods/get-news-newest-details";
import { getBranchDetails } from "./branches/methods/get-branch-details";
import { getProductsListByBrand } from "./brands/methods/get-products-list-by-brand";
import { getProductsListBySearch } from "./products/methods/get-products-by-search";

import { sendContactUsForm } from "./contactUsForm/methods/send-contactUsForm";
import { getStates } from "./contactUsForm/methods/getStates";
import { getMunicipalitiesByState } from "./contactUsForm/methods/getMunicipalitiesByState";
import { getFiltersForBrands } from "./filters/methods/get-filters-for-brands";

export const API = {

    contactUsForm:{
        sendContactUsForm,
        getStates,
        getMunicipalitiesByState
    },
    slider: {
        getSlider,
    },
    news: {
        getAllNews,
        getNewsCategory,
        getNewsYearMonth,
        getNewsList,
        getNewsCategoryList,
        getNewsDetails,
        getNewsListBySearch,
        getNewsNewestDetails,
    },
    promotion: {
        getPromotion,
        getPromotionList,
        getPromotionDetails,
        getFeaturedList,
        getPromotionLatestList,
    },
    menu: {
        getMenu
    },
    contact: {
        getContact
    },
    usedProduct: {
        getUsedProductsList,
        getFeatureds,
        getUsedProductsFamilies,
        getUsedProductsIndustries,
        getUsedProductsListByIndustry,
        getUsedProductsListByFamily,
        getUsedProductsListBySearch,
        getUsedProductDetails,
    },
    products: {
        getProductsList,
        getProductDetails,
        getProductsListBySearch,
    },
    filters: {
        getFilters,
        getFiltersForBrands
    },
    industry: {
        getIndustry,
        getIndustryBySlugAndFamilies
    },
    tire: {
        getTireList,
        getTireIndustry,
        getTireDetails,
        getTireListFiltered,
        getTireListBySearch,
    },
    partsServices: {
        getOverview,
        getCategories,
        getCategoryDetails,
        getSubCategoryDetails,
    },
    technologicalSolutions: {
        getTechnologicalSolutions,
        getTechnologicalSolution,
    },
    branches: {
        getBranches,
        getBranchDetails,
    },
    contentUsedProductCertificate: {
      getContentUsedProductCertificateDetails
    },
    booklets: {
        getBookletList,
        getBookletCategory,
        getBookletDate,
        getBookletListByCategory,
        getBookletListBySearch,
        GetBookletDetails,
    },
    brands:{
        getBrandList,
        getProductsListByBrand,
    }
} 